export default defineNuxtPlugin(() => {
    const globalStore = useGlobalStore();
    const { initialize } = useGtag();
    let started = false;

    const start = () => {
        if (started) return;
        started = true;
        initialize();
    };

    const runWhenIdle = (fn) => {
        if (typeof window.requestIdleCallback === "function") {
            window.requestIdleCallback(fn, { timeout: 2500 });
            return;
        }
        window.setTimeout(fn, 400);
    };

    watch(
        () => globalStore.appLoadingComplete,
        (ready) => {
            if (!ready) return;
            runWhenIdle(start);
        },
        { immediate: true }
    );
});
